import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from "../../config/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import NavBar from "../components/NavBar";
import {
    Button,
    Card,
    DatePicker,
    Descriptions,
    Form,
    Input,
    Checkbox,
    Upload,
    UploadProps,
    Select,
    InputNumber, Switch
} from "antd";
import Colors from "../../styles/Colors";
import toast, { Toaster } from "react-hot-toast";
import { PutUsuariIdPerfil } from "../../dao/root/PutUsuariIdPerfil";
import { GetUsuariIdPerfil } from "../../dao/root/GetUsuariIdPerfil";
import Login from "./Login";
import Password from "antd/es/input/Password";
import {UploadOutlined} from "@ant-design/icons";
import {BiFilter, BiPencil, BiPlus, BiRefresh} from "react-icons/bi";
import PlantillaModal from "../PlantillaModal";
import ConfiguracioAppModal from "./component/ConfiguracioAppModal";
import dayjs from "dayjs";
import { defaultUser, User } from '../../model/root/User';
import ProfileModal from './component/ProfileModal';

const Profile = () => {
    const { isLoggedIn, userId, page } = useContext(AuthContext);
    const { id_usuari } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [usuari, setUsuari] = useState<any>({});
    const [editMode, setEditMode] = useState(false);
    const [modal, setModal] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [elementSelected, setElementSelected] = useState<User>(defaultUser);

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true);
            checkDades();
        }
    }, [id_usuari, page, isLoggedIn]);

    async function checkDades() {
        handleLoadingChange(true);
        const dades = await GetUsuariIdPerfil(id_usuari || userId, page);
        console.log(dades);
        console.log(transformarDades(dades[0]));
        setUsuari(dades && dades.length > 0 ? transformarDades(dades[0]) : {});
        handleLoadingChange(false);
    }

    function transformarDades(original: any) {
        const naixFills = original.naix
            .replace(/^\[|\]$/g, '') // quitamos los corchetes
            .split(', ')
            .map((dateStr:any) => {
                const cleaned = dateStr.replace(/CEST|CET|GMT\+\d+|UTC/g, '').trim();
                const dateObj = new Date(cleaned);
                return isNaN(dateObj.getTime()) ? null : dayjs(dateObj);

            })
            .filter((date: any): date is string => date !== null); // filtramos nulls con tipo TypeScript

        // Extraemos las disciplines limpiamente
        const disciplines = original.disciplines
            .replace(/^\[|\]$/g, '') // quitamos los corchetes
            .split(', ')
            .map((d: any) => d.trim());
        const naix = naixFills.map((date: dayjs.Dayjs) => date.year()).join(', ');
        return {
            ...original,
            naix: naix,
            grauDiscapacitatDetall: original.discapacitat,
            convivencia: original.convivencia === 1,
            disciplines: disciplines,
            naixFills: naixFills
        };
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function handleSave(values: any) {
        handleLoadingChange(true);
        const formData = form.getFieldsValue();
        console.log(formData);
        if (formData.nuevaPassword === formData.repetirNovaPassword) {
            const status = await PutUsuariIdPerfil(id_usuari || userId || "0", page, formData);
            setEditMode(false);
            if (status === 200 || status === 201) {
                toast.success("Dades guardades correctament!");
                await checkDades();
            } else {
                toast.error("Error guardant dades!");
                handleLoadingChange(false);
            }
        } else {
            toast.error("Les contrasenyes no cincideixen!");
            handleLoadingChange(false);
        }
    }

    function handleCloseModal() {
        setNouElement(false);
        checkDades();
    }
    function handleCloseModal2(value: boolean) {
        setModal(false);
    }

    function togleNouElement(element: User) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function afegirElement(element: User) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }


    if (isLoggedIn) {
        return (
            <div>
                <Toaster />
                <NavBar />
                {!loading ? (
                    <div className="general">
                        <Card bordered className="elemento">
                            <div className={"actionButtons"}>
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(defaultUser)}><BiPencil/></Button>
                                <Button title={"refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                    checkDades()}><BiRefresh/></Button>
                            </div>
                            <h4 className="titol">Dades usuari</h4>
                            <Descriptions bordered column={1} size="small">
                                    <Descriptions.Item key={1}
                                        label={"Nom"}>
                                        {usuari.nombre}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={2}
                                        label={"Cognoms"}>
                                        {usuari.cognoms}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={3}
                                        label={"DNI"}>
                                        {usuari.dni}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={4}
                                                       label={"Correu electrònic"}>
                                        {usuari.correu}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={5}
                                        label={"Seguretat Social"}>
                                        {usuari.seguretatSocial}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={6}
                                        label={"IBAN"}>
                                        {usuari.iban}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={7}
                                        label={"Telèfon de contacte"}>
                                        {usuari.telefon}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={8}
                                        label={"Telèfon alternatiu"}>
                                        {usuari.telefon2}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={12}
                                        label={"Domicili"}>
                                        {usuari.domicili}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={13}
                                        label={"Grau de discapacitat"}>
                                        {usuari.discapacitat}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={14}
                                        label={"Convivència amb majors de 26 amb dependència"}>
                                        {usuari.convivencia ? "Sí" : "No"}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={9}
                                        label={"Disciplines"}>
                                        {usuari.disciplines?.toString()}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={9}
                                        label={"Anys naixements fills"}>
                                        {usuari.naix}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={9}
                                        label={"Carnet de monitor"}>
                                        {usuari.monitor}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={10}
                                        label={"CV"}>
                                        {usuari.cv}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={11}
                                        label={"Certificat de delictes sexuals"}>
                                        {usuari.sexuals}
                                    </Descriptions.Item>
                                    <Descriptions.Item key={15}
                                        label={"Configuració de l'app"}>
                                        <b style={{cursor: "pointer"}} onClick={() => setModal(true)}>Fes click per mostrar instruccions</b>
                                    </Descriptions.Item>
                                </Descriptions>
                            <br/>
                            {nouElement && (
                                <ProfileModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                            page={page}/>
                            )}
                        </Card>
                    </div>
                ) : (

                    <div className="general">
                        <Card bordered className="elemento">
                            <div className={"actionButtons"}>
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(defaultUser)}><BiPencil/></Button>
                                <Button title={"refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                    checkDades()}><BiRefresh/></Button>
                            </div>
                            <h4 className="titol">Dades usuari</h4>
                            <Descriptions bordered column={1} size="small">
                                <Descriptions.Item key={1}
                                                   label={"Dades"}>
                                    {"Carregant dades..."}
                                </Descriptions.Item>
                                <Descriptions.Item key={15}
                                                   label={"Configuració de l'app"}>
                                    <b style={{cursor: "pointer"}} onClick={() => setModal(true)}>Fes click per mostrar instruccions</b>
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </div>
                )}
                <ConfiguracioAppModal onClose={handleCloseModal2} visible={modal} app={usuari.app} ios={usuari.ios}/>
            </div>
        );
    } else {
        return <Login />;
    }
};
export default Profile;
